import { render, staticRenderFns } from "./inregModal.vue?vue&type=template&id=7d967cb4&scoped=true&"
import script from "./inregModal.vue?vue&type=script&lang=js&"
export * from "./inregModal.vue?vue&type=script&lang=js&"
import style0 from "./inregModal.vue?vue&type=style&index=0&id=7d967cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d967cb4",
  null
  
)

export default component.exports